/* eslint-disable no-new-object */

import * as Constants from 'utils/Constants';

import HelperFunctions from "utils/HelperFunctions";
import {
    MARKETING_PLAY_REPORTS
} from "redux/constants/action-types";
import axios from 'axios';

export function GetMarketingPlaysRevenueDetail(campaignName, isAdHocOnly, startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            if (!isAdHocOnly) {
                isAdHocOnly = "";
            }
            
            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetMarketingPlaysRevenueDetails?clientId=' + clientId + '&campaignName&isAdHocOnly=' + isAdHocOnly + '&startDate=' + startDate + '&endDate=' + endDate;

            if (campaignName) {
                URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetMarketingPlaysRevenueDetails?clientId=' + clientId + '&campaignName=' + encodeURIComponent(campaignName) + '&isAdHocOnly=' + isAdHocOnly + '&startDate=' + startDate + '&endDate=' + endDate;
            }
            const response = await axios.get(URL);
            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_MARKETING_PLAYS_REVENUE_DETAIL,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error, error);
        }
    };
}


export function loadRevenueHeatMapData(clientId, startDate, endDate) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            }
            else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetRevenueByGeography?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);
            dispatch({
                type: MARKETING_PLAY_REPORTS.UPDATE_HEAT_MAP_DATA,
                payload: response.data
            });
        } catch (error) {
            console.log("error", error);
        }
    };
}

export function GetMarketingPlayRevenueByChannel(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetRevenueByChannel?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_REVENUE_BY_CHANNEL,
                payload:  response.data
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}


export function GetTotalAndAdhocRevenue(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetTotalRevenue?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_TOTAL_ADHOC_REVENUE,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}
export function GetAverageEmailOpenRateOverTime(startDate, endDate) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetAverageEmailOpenRateOverTime?startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_AVG_OPEN_EMAIL_RATE,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

//TODO: To be removed
export function GetPlaysRevenue(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }


            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetRevenueByPlay?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_PLAYS_REVENUE,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function GetTotalAndRemainingTouchpoints(clientId) {
    return async function (dispatch) {
        try {

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetTouchPointCounts?clientId=' + clientId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_TOTAL_AND_REMAINING_TOUCHPOINTS,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

//TODO: To be removed
export function GetClientsPlaywithTotalRevenue(startDate, endDate, clientId, isPlayDetailCall = false) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetMarketingPlayWithTotalRevenue?clientId=' + clientId + '&startDate=' + startDate + "&endDate=" + endDate;

            const response = await axios.get(URL);
            if (isPlayDetailCall) {
                dispatch({
                    type: MARKETING_PLAY_REPORTS.GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE_PLAY_DETAIL,
                    payload: HelperFunctions.responseHandlerVNext(response.data)
                });
            } else {
                dispatch({
                    type: MARKETING_PLAY_REPORTS.GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE,
                    payload: HelperFunctions.responseHandlerVNext(response.data)
                });
            }

        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

//TODO: To be removed
export function GetPlayRevenueOverTimeCumulative(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetPlaysCumulativeRevenueOverTime?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_CUMULATIVE,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

//TODO: To be removed
export function GetPlayRevenueOverTimeMonthly(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetPlaysMonthlyRevenueOverTime?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_MONTHLY,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function GetTouchPointsCumulativeRevenueOverTime(clientId, playId, startDate, endDate) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetTouchPointsCumulativeRevenueOverTime?clientId=' + clientId + '&playId=' + playId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.TOUCHPOINTS_CUMULATIVE_REVENUE_OVER_TIME,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function GetTopPlaysRevenue(clientId, startDate, endDate) {
    return async function (dispatch) {
        try {

            if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            } else {
                startDate = "";
                endDate = "";
            }

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetTopPlaysRevenue?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.TOP_PLAYS_REVENUE,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function GetDesignByTouchpointId(clientId, touchpointId) {
    return async function (dispatch) {
        try {

            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/GetDesignByTouchpointId?clientId=' + clientId + '&touchpointId=' + touchpointId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.DESIGN_BY_TOUCHPONT_ID,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}


// export function ManageCampaignGetSummary(startDate, endDate, clientId) {
//     return async function (dispatch) {
//         try {
//            /* if (startDate & endDate) {
//                 //startDate = startDate.toJSON();
//                 //endDate = endDate.toJSON()
//             }

//             if(startDate == null & endDate ==null) {
//                 startDate = "";
//                 endDate = "";
//             }*/
//             if(startDate == null & endDate ==null) {
//                 startDate = "";
//                 endDate = "";
//             }
            
//             let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/ManageCampaignGetSummary?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

//             const response = await axios.get(URL);
//             dispatch({
//                 type: MARKETING_PLAY_REPORTS.GET_MANAGE_CAMPAIGN_SUMMARY,
//                 payload: HelperFunctions.responseHandlerVNext(response.data)
//             });
//         } catch (error) {
//             console.log("error", error.response);
//             console.log(typeof error);
//         }
//     };
// }

export function ManageCampaignGetDetail(startDate, endDate, clientId) {
    return async function (dispatch) {
        try {

            /*if (startDate & endDate) {
                startDate = startDate.toJSON();
                endDate = endDate.toJSON()
            }
            else {
                startDate = "";
                endDate = "";
            }*/
            if(startDate == null & endDate ==null) {
                startDate = "";
                endDate = "";
            }
            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/ManageCampaignGetDetail?clientId=' + clientId + '&startDate=' + startDate + '&endDate=' + endDate;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETING_PLAY_REPORTS.GET_MANAGE_CAMPAIGN_DETAIL,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}


export function AddToManageCampaign(clientId ,marketingPlayId ,templateId ,campaignName ,subject) {
    return async function (dispatch) {
        try {
            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/AddToManageCampaign';//?clientId=' + clientId + '&marketingPlayId=' + marketingPlayId + '&templateId=' + templateId+'&campaignName='+campaignName+'&subject='+subject;

            await axios.post(URL, null, {
                params: {
                    clientId: clientId,
                    marketingPlayId: marketingPlayId,
                    templateId: templateId,
                    campaignName: campaignName,
                    subject: subject,
                }
            });

        } catch (error) {
            console.log("error", error);
        }
    };
}

export function RemoveFromManageCampaign(clientId ,marketingPlayId ,templateId ,campaignName ,subject) {
    return async function (dispatch) {
        try {
            let URL = Constants.VNEXT_BASE_URL + 'Report/MarketingPlayReports/RemoveFromManageCampaign';

            await axios.post(URL, null, {
                params: {
                    clientId: clientId,
                    marketingPlayId: marketingPlayId,
                    templateId: templateId,
                    campaignName: campaignName,
                    subject: subject,
                }
            });

        } catch (error) {
            console.log("error", error);
        }
    };
}